export const noResultsMessage = (type) => `There is no ${type} data available for the filters selected. Try modifying or removing a filter to see results.`
